/*
 * Copyright (c) 2018 Wells Fargo. 455 Market St., San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description: Utility function to set focus on an element. Done this way to 
 facilitate unit testing, given that we can easily mock this.
*/
export var focusElement = function focusElement(element) {
  return element.focus();
};